import { Component, OnInit, ViewChild } from '@angular/core';
import { ListpluginsComponent } from 'projects/core/src/common/settingwindow/listplugins/listplugins.component';
import { CSettingWindow, ISettingWindow } from 'projects/core/src/include/settingwindow';
import { SystemService } from 'projects/core/src/lib/system.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css'
})

@ISettingWindow.register
export class ProjectSettingsComponent extends CSettingWindow implements OnInit {
  
  @ViewChild(ListpluginsComponent)
  listplugins:ListpluginsComponent;
  
  tab='2';
  constructor(
      public systemService:SystemService,
    ){
      super(systemService);
      this.getServerPluginsSettings("project");
      
    }
  
  ngOnInit(): void {
    
  }

  save(){
  }

}
